import styled, { css } from 'styled-components';
import { DRAG_HELPER_CLASS } from '../consts';
export const DragHandle = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 48px;

  opacity: 0;
  color: var(--icon-secondary);

  cursor: move;
  cursor: grab;

  &:hover {
    color: var(--icon-primary);
  }
`;
export const Options = styled.div `
  display: flex;
  align-items: center;

  opacity: 0;
`;
export const Wrapper = styled.div `
  background: var(--bg-primary);
  padding: 0 var(--space-200);
  border-bottom: 1px solid var(--border-secondary);

  &:hover {
    ${DragHandle}, ${Options} {
      opacity: 1;
    }
  }

  ${({ $hoverable }) => $hoverable &&
    css `
      cursor: pointer;

      &:hover {
        background: var(--bg-transparent);
      }

      &:active {
        background: var(--bg-transparent-strong);
      }
    `};

  ${({ $highlighted }) => $highlighted &&
    css `
      background: var(--bg-brand-secondary);
    `};

  &:last-child {
    border-bottom: none;
    border-bottom-right-radius: var(--radius-brand);
    border-bottom-left-radius: var(--radius-brand);
  }
`;
export const Row = styled.div `
  position: relative;
  display: flex;
  align-items: stretch;

  &.${DRAG_HELPER_CLASS} {
    pointer-events: auto !important;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    z-index: 999;

    ${DragHandle} {
      cursor: grabbing;
    }
  }
`;
export const ChildrenContainer = styled.div `
  flex: 1;
`;
export const Children = styled.div `
  display: flex;
  align-items: stretch;
`;
export const Footer = styled.footer `
  background: var(--bg-primary);
`;
